const base_path = "/new_images/ceramic_coating/16__Others/";

const file_names: string[] = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
]

const file_names_sizes: {[key: string]: {w: number, h: number}} = {
    "1": {w: 1080, h: 717},
    "2": {w: 1080, h: 717},
    "3": {w: 1080, h: 810},
    "4": {w: 1080, h: 810},
    "5": {w: 1080, h: 717},
    "6": {w: 1080, h: 717},
    "7": {w: 1080, h: 810},
    "8": {w: 1080, h: 717},
    "9": {w: 810, h: 1080},
    "10": {w: 1080, h: 717},
    "11": {w: 1080, h: 810},
    "12": {w: 1080, h: 717},
    "13": {w: 1080, h: 810},
    "14": {w: 1080, h: 717},
    "15": {w: 717, h: 1080},
}

export const Others = file_names.map((f) => {
    const size = file_names_sizes[f];

    return {
        jpg: base_path+f+".jpeg",
        webp: base_path+f+".webp",
        alt: "",
        w: size.w.toString(),
        h: size.h.toString(),
    }
});